import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BasicResponse } from '@auth-suite-services/services';
// See C001 - 2026-08-20 - HE
// import { ConfigService } from '@auth-suite-services/services';
import { mbeConfigService } from './mbe-config.service';
import { Observable } from 'rxjs';
import { ProductListAPI, ProductList } from '../model/product-list';

/**
 * @description
 * @class
 */
@Injectable({ providedIn: 'root' })
export class ProductListService {
  private URL;
  headers: HttpHeaders;

  constructor(
    // See C001 - 2026-08-20 - HE
    // @Inject(ConfigService) private config: any,
    @Inject(mbeConfigService) private config: any,
    private httpClient: HttpClient
  ) {
    this.URL =
      config.REST_SERVER_HOST +
      config.REST_SERVER_url.find((restUrl) => restUrl.api === 'MBE').url;
    this.headers = new HttpHeaders().set('DoNotIntercept', 'true');
  }

  getAllProductList(
    pageIndex: number,
    pageSize: number,
    sortActive: string,
    sort: string
  ): Observable<ProductListAPI> {
    const headers = this.headers;
    const jsonObject = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortActive: sortActive,
      sort: sort,
    };

    return this.httpClient.post<ProductListAPI>(
      `${this.URL}/pli/allpli`,
      jsonObject,
      { headers }
    );
  }

  createNewPLI(pli: ProductList): Observable<BasicResponse> {
    const headers = this.headers;
    const jsonObject = {
      category: pli.category+"",
      origin: +pli.origin,
      feeAmount: +pli.feeAmount,
      productAmount: +pli.productAmount,
      productCode: pli.productCode,
      productDescription: pli.productDescription,
      status: pli.status,
    };
    console.log(jsonObject);
    return this.httpClient.post<BasicResponse>(
      `${this.URL}/pli/createpli`,
      jsonObject,
      { headers }
    );
  }

  getProductList(id: number) {
    const headers = this.headers;
    const jsonObject = {
      id: id,
    };
    return this.httpClient.post<ProductList>(
      `${this.URL}/pli/onepli`,
      jsonObject,
      { headers }
    );
  }

  updatePLI(pli: ProductList, id: number) {
    const headers = this.headers;
    const jsonObject = {
      id: id,
      category: pli.category,
      origin: +pli.origin,
      feeAmount: pli.feeAmount,
      productAmount: pli.productAmount,
      productCode: pli.productCode,
      productDescription: pli.productDescription,
      status: pli.status,
    };
    console.log(jsonObject);
    return this.httpClient.post<BasicResponse>(
      `${this.URL}/pli/updatepli`,
      jsonObject,
      { headers }
    );
  }
}

// ========================================
// CHANGE LOG
// ========================================
// C001: Switched ProductListService constructor injection from ConfigService (imported from '@auth-suite-services/services') to mbeConfigService. Previous behavior: Imported ConfigService from the services barrel, but that token is not a public export of index.ts, causing TS2305 Module has no exported member 'ConfigService' and failing portaladmin:build. New behavior: Injects mbeConfigService like other MBE HTTP services; URL is still REST_SERVER_HOST + REST_SERVER_url MBE. Reason: Unblock portaladmin development build. Context: /build-and-lint 2026-08-20. Impact: Same environment object is provided by MBEServiceModule.forRoot; no API path change. - 2026-08-20 - HE

